/**
 * Início do Consórcio Canopus (em teste, só super admin): o que já trazemos do
 * AFV — planos à venda, vendas, clientes, comissões e carteira — e de quando é o retrato.
 */
import { Link } from 'react-router';
import { useGetList } from 'ra-core';
import { Banknote, Landmark, Layers, ShoppingCart, UserCheck, Wallet } from 'lucide-react';
import { dataHora } from './CanopusListas';
import { CabecalhoPagina } from '../bento/ui';

function useTotal(recurso: string, filtro: Record<string, unknown> = {}) {
  const { total, data, isPending } = useGetList<{ id: number; sync_at?: string }>(recurso, {
    filter: filtro,
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'sync_at', order: 'DESC' },
  });
  return { total: total ?? 0, ultimo: data?.[0]?.sync_at ?? null, carregando: isPending };
}

function Caixa({ to, icone, titulo, valor, detalhe }: { to: string; icone: React.ReactNode; titulo: string; valor: string; detalhe: string }) {
  return (
    <Link to={to} className="cartao border-t-ouro flex cursor-pointer flex-col gap-1 bg-card px-4 py-3.5 transition-colors hover:bg-muted/40">
      <span className="flex items-center gap-2 text-[10.5px] font-bold uppercase tracking-[0.08em] text-muted-foreground">{icone}{titulo}</span>
      <span className="mt-1 text-[22px] font-bold leading-none tabular-nums text-marinho">{valor}</span>
      <span className="mt-1 text-xs text-muted-foreground">{detalhe}</span>
    </Link>
  );
}

export function CanopusInicio() {
  const planos = useTotal('canopus_planos', { com_reserva: false });
  const vendas = useTotal('canopus_vendas');
  const clientes = useTotal('canopus_clientes');
  const comissoes = useTotal('canopus_comissoes');
  const atrasadas = useTotal('canopus_carteira', { situacao: 'atrasada' });
  const app = useTotal('canopus_vendas_app');
  const n = (x: { total: number; carregando: boolean }) => (x.carregando ? '…' : String(x.total));

  return (
    <div className="space-y-5">
      <CabecalhoPagina
        titulo={<span className="flex items-center gap-2"><Landmark className="h-6 w-6 text-ouro" />Consórcio Canopus</span>}
        descricao={<>Em teste. Dados do AFV da Canopus, atualizados pelo sync{planos.ultimo ? ` (último: ${dataHora(planos.ultimo)})` : ''}.</>}
      />
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        <Caixa to="/canopus/planos" icone={<Layers className="h-4 w-4" />} titulo="Planos à venda" valor={n(planos)} detalhe="sem reserva de cota" />
        <Caixa to="/canopus/vendas" icone={<ShoppingCart className="h-4 w-4" />} titulo="Vendas" valor={n(vendas)} detalhe={`pedidos da North no AFV · ${n(app)} pelo app`} />
        <Caixa to="/canopus/clientes" icone={<UserCheck className="h-4 w-4" />} titulo="Clientes" valor={n(clientes)} detalhe="cadastrados no AFV" />
        <Caixa to="/canopus/comissoes" icone={<Banknote className="h-4 w-4" />} titulo="Comissões a receber" valor={n(comissoes)} detalhe="do último sync" />
        <Caixa to="/canopus/carteira" icone={<Wallet className="h-4 w-4" />} titulo="Cotas em atraso" valor={n(atrasadas)} detalhe="carteira do AFV" />
      </div>
    </div>
  );
}
